export class FaqCategory {
    constructor(public id: number, public name: string, public displayOrder: number) {}
}
